import React from 'react'
import seqStore from '../../store/seqStore'

export default function Tempo() {
    const tempo =seqStore((state) => state.tempo)
    const setTempo = seqStore((state) => state.setTempo)

    // TEMPO CONTROLS
    const handleTempo = (e) => {
        const value = e.target.value
        setTempo(value)
    }

    const resetTempo = () => {
        setTempo(120)
    }
    

    return (
        <div id='tempoInput'>
            <label htmlFor='sequencer_tempo'><p>Tempo: <span>{tempo}bpm</span></p></label>
            <input id='enabledInput' type="range" min={30} max={300} step='1' value={tempo} onChange={e=> handleTempo(e)} onDoubleClick={resetTempo}/>
        </div> 
    )
}
